<template>
    <div class="p-4 lg:w-full md:w-full">
        <div class="space-y-4">
            <div class="field w-full mb-3" v-for="(file, index) in file_uploads" :key="index">
                <div v-if="!(exlude_hps && file.kode_file == 'hps')">
                    <div class="flex items-start w-full">
                        <label :for="file.kode_file" class="text-gray-700 font-bold mr-4 w-1/4">
                            {{ file.file_dokumen_type.nama }}
                            <span v-if="file.is_required === 1" class="text-red-500 ml-1">*</span>
                            <span v-if="file.multiple" class="text-sm text-gray-500 ml-2">(Anda dapat mengunggah lebih
                                dari
                                satu file)</span>
                        </label>
                        <div class="w-3/4">
                            <!-- Informasi file yang diperbolehkan -->
                            <div class="mb-2 p-2 bg-blue-50 border border-blue-200 rounded text-sm">
                                <div class="flex items-start">
                                    <i class="pi pi-info-circle text-blue-600 mt-0.5 mr-2"></i>
                                    <div>
                                        <span class="font-medium text-blue-800">Format file yang diperbolehkan:</span>
                                        <span class="text-blue-700 ml-1">{{ getFileTypeInfo(file.kode_file) }}</span>
                                        <div v-if="getFileSizeInfo(file.kode_file)" class="text-blue-600 mt-1">
                                            <span class="font-medium">Ukuran maksimal:</span>
                                            <span class="ml-1">{{ getFileSizeInfo(file.kode_file) }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                                                        <div class="flex items-center bg-gray-100 p-4 rounded-lg w-full">
                                <template v-if="file.new_file && file.new_file.length > 0 && !file.multiple">
                                    <div class="w-full">
                                        <div class="flex items-center justify-between bg-gray-200 p-2 rounded mb-1">
                                            <small class="text-gray-700">{{ file.new_file[0].name }}</small>
                                            <Button icon="pi pi-trash" @click="removeFileUpload(index, 0)"
                                                class="p-button-text p-button-sm p-button-danger ml-2" />
                                        </div>
                                    </div>
                                </template>
                                <template v-else>
                                    <FileUpload :mode="'basic'" :name="file.kode_file" :maxFileSize="10000000"
                                        :chooseLabel="file.multiple && file.new_file && file.new_file.length > 0 ? 'Tambah File' : 'Pilih File!'"
                                        :auto="true" customUpload
                                        :accept="getAcceptType(file.kode_file)"
                                        @select="selectFile($event, index)" class="w-full">
                                        <template #empty>
                                            <div class="text-center p-4 border-2 border-dashed border-gray-300 rounded">
                                                <i class="pi pi-upload text-2xl text-gray-400 mb-2"></i>
                                                <p class="text-gray-600 mb-1">Klik untuk memilih file</p>
                                                <p class="text-sm text-gray-400">{{ getFileTypeInfo(file.kode_file) }}</p>
                                            </div>
                                        </template>
                                    </FileUpload>
                                </template>
                            </div>
                        </div>
                    </div>
                    <div class="mt-2" v-if="file.multiple">
                        <div v-for="(new_file, nfIndex) in file.new_file" :key="nfIndex"
                            class="flex items-center bg-gray-200 p-2 rounded mb-1">
                            <small class="text-gray-700 flex-1">{{ new_file ? new_file.name : '' }}</small>
                            <Button icon="pi pi-trash" @click="removeFileUpload(index, nfIndex)"
                                class="p-button-text p-button-sm p-button-danger ml-2" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue'
import Fieldset from 'primevue/fieldset';
import FileUpload from 'primevue/fileupload';
import Button from 'primevue/button';
import { required } from '@vuelidate/validators';

export default defineComponent({
    components: {
        Fieldset,
        FileUpload,
        Button
    },
    props: {
        file_uploads: Array,
        exlude_hps: Boolean,
    },
    methods: {
        selectFile(event, index) {
            if (this.file_uploads[index].multiple) {
                this.file_uploads[index].new_file.push(...event.files);
            } else {
                this.file_uploads[index].new_file = event.files;
            }
        },
        removeFileUpload(fileIndex, nfIndex) {
            this.file_uploads[fileIndex].new_file.splice(nfIndex, 1);
        },
        getAcceptType(kode_file) {
            switch (kode_file) {
                case 'kerangka_acuan_kerja':
                case 'draft_kontrak':
                case 'dokumen_pemilihan':
                case 'surat_penawaran':
                case 'dokumen_kualifikasi':
                case 'dokumen_teknis':
                case 'ba_penjelasan':
                case 'ba_klarifikasi':
                case 'ba_evaluasi':
                case 'ba_penawaran':
                case 'ba_negosiasi':
                case 'ba_penunjukan':
                    return 'application/pdf,.pdf';
                case 'bq_spesifikasi':
                case 'hps':
                case 'dokumen_harga':
                    return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,.xlsx,.xls';
                case 'dokumen_lain':
                    return 'application/pdf,.pdf,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,.xlsx,.xls,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/msword,.docx,.doc';
                default:
                    return '';
            }
        },
        getFileTypeInfo(kode_file) {
            switch (kode_file) {
                case 'kerangka_acuan_kerja':
                    return 'PDF (.pdf)';
                case 'draft_kontrak':
                    return 'PDF (.pdf)';
                case 'bq_spesifikasi':
                    return 'Excel (.xlsx, .xls)';
                case 'dokumen_pemilihan':
                    return 'PDF (.pdf)';
                case 'hps':
                    return 'Excel (.xlsx, .xls)';
                case 'dokumen_lain':
                    return 'PDF (.pdf), Excel (.xlsx, .xls), Word (.docx, .doc)';
                case 'surat_penawaran':
                    return 'PDF (.pdf)';
                case 'dokumen_kualifikasi':
                    return 'PDF (.pdf)';
                case 'dokumen_teknis':
                    return 'PDF (.pdf)';
                case 'dokumen_harga':
                    return 'Excel (.xlsx, .xls)';
                case 'ba_penjelasan':
                    return 'PDF (.pdf)';
                case 'ba_klarifikasi':
                    return 'PDF (.pdf)';
                case 'ba_evaluasi':
                    return 'PDF (.pdf)';
                case 'ba_penawaran':
                    return 'PDF (.pdf)';
                case 'ba_negosiasi':
                    return 'PDF (.pdf)';
                case 'ba_penunjukan':
                    return 'PDF (.pdf)';
                default:
                    return 'Semua format file';
            }
        },
        getFileSizeInfo(kode_file) {
            switch (kode_file) {
                case 'kerangka_acuan_kerja':
                case 'draft_kontrak':
                case 'dokumen_pemilihan':
                case 'surat_penawaran':
                case 'dokumen_kualifikasi':
                case 'dokumen_teknis':
                case 'ba_penjelasan':
                case 'ba_klarifikasi':
                case 'ba_evaluasi':
                case 'ba_penawaran':
                case 'ba_negosiasi':
                case 'ba_penunjukan':
                    return '10 MB';
                case 'bq_spesifikasi':
                case 'hps':
                case 'dokumen_harga':
                    return '10 MB';
                case 'dokumen_lain':
                    return '10 MB';
                default:
                    return '10 MB';
            }
        }
    }
});
</script>
